import { axiosInstance } from "./axios-config";

export class BlogPostApi {
  /**
   * @param {PostListRequest} data - Request body parameters
   * @param {string} [data.categoryId] - Filter by category ID
   * @param {number} [data.pageNo] - Page number (0-based)
   * @param {number} [data.pageSize] - Number of posts per page
   * @param {PostStatus} [data.status] - Filter by status (e.g., "Published")
   * @param {string} [data.searchString] - Search query
   * @param {string} [data.sortOrder] - Sort order
   * @param {string} [data.fromDate] - Filter from date
   * @param {string} [data.toDate] - Filter to date
   * @returns {Promise<PostListResponse>}
   */
  getAll = async (data = {}) => {
    const response = await axiosInstance.post("/blog/posts/post-list", data);
    return response;
  };

  /**
   * @param {string} slug - Post slug
   * @returns {Promise<{post: PostResponse}>}
   */
  getBySlug = async (slug) => {
    const response = await axiosInstance.get(`/blog/posts/slug/${slug}`);
    return response;
  };
}
